import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Cost} from "../../models/cost";
import {FixCost} from "../../models/fix-cost";
import {FormulaCost} from "../../models/formula-cost";
import {FormulaCostItem} from "../../models/formula-cost-item";
import {Registration} from "../../models/registration";
import Helpers from "../../utils/helpers";

@Injectable()
export class CostControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getRegistrationCostList(registrationId: string): Observable<Cost[]> {
    return this.http.get(this.baseUrl + "registration/" + registrationId + "/cost") as Observable<Cost[]>;
  }

  //  public getCost(costId: string): Observable<Cost> {
    //  return this.http.get(this.baseUrl + "cost/" + costId) as Observable<Cost>;
  //  }

  public getCostRegistrations(serviceId: string, fieldKey: string): Observable<Registration[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/cost/field/" + fieldKey) as Observable<Registration[]>;
  }

  public createCost(registrationId: string, cost: Cost) {
    return this.callCreateCost(registrationId, "cost", cost);
  }

  public createFixCost(registrationId: string, cost: FixCost) {
    return this.callCreateCost(registrationId, "fixcost", cost);
  }

  public createFormulaCost(registrationId: string, cost: FormulaCost) {
    return this.callCreateCost(registrationId, "formulacost", cost);
  }

  public saveCost(cost: Cost) {
    return this.callSaveCost(cost, "cost");
  }

  public saveFixCost(cost: FixCost) {
    return this.callSaveCost(cost, "fixcost");
  }

  public saveFormulaCost(cost: FormulaCost) {
    return this.callSaveCost(cost, "formulacost");
  }

  public deleteCost(costId: string) {
    return this.http.delete(this.baseUrl + "cost/" + costId, {responseType: "text"});
  }

  private callCreateCost(registrationId: string, type: string, cost: Cost) {
    Helpers.trimRecursiveObj(cost);
    return this.http.post(this.baseUrl + "registration/" + registrationId + "/" + type, JSON.stringify(cost));
  }

  public sortCosts(registrationId: string, costs: Cost[]) {
    return this.http.put(this.baseUrl + "registration/" + registrationId + "/sort_costs", JSON.stringify(costs));
  }

  private callSaveCost(cost: Cost, type: string) {
    Helpers.trimRecursiveObj(cost);
    return this.http.put(this.baseUrl + type, JSON.stringify(cost), {responseType: "text"});
  }

  public createFormulaCostItem(formulaCostItem: FormulaCostItem) {
    const json: any = formulaCostItem;
    return this.http.post(this.baseUrl + "formulacostitem", json);
  }

  public saveFormulaCostItem(formulaCostItem: FormulaCostItem) {
    const json: any = formulaCostItem;
    return this.http.put(this.baseUrl + "formulacostitem", json);
  }

  public deleteFormulaCostItem(formulaCostItemId: string) {
    return this.http.delete(this.baseUrl + "formulacostitem/" + formulaCostItemId);
  }

  public getCurrencies(): Observable<any[]> {
    return this.http.get(this.baseUrl + "currency") as Observable<any[]>;
  }

}
